function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { getFieldType, retrieveSchema, mergeObjects, toIdSchema, getDefaultRegistry, getDefaultFormState, getUiOptions } from './';
export function getFieldSchema(props) {
  const _getFieldType = getFieldType(props),
        schema = _getFieldType.schema;

  return schema || {};
}
export function getFieldUiSchema(props) {
  const _getFieldType2 = getFieldType(props),
        uiSchema = _getFieldType2.uiSchema;

  return uiSchema || {};
}
export function getField(props) {
  props = getFieldType(props); // registry

  const registry = props && props.registry || getDefaultRegistry();
  const definitions = registry.definitions,
        fields = registry.fields,
        formContext = registry.formContext; // get props

  let _props = props,
      formData = _props.formData,
      schema = _props.schema,
      uiSchema = _props.uiSchema,
      errorSchema = _props.errorSchema,
      idSchema = _props.idSchema,
      idPrefix = _props.idPrefix,
      name = _props.name; // defs

  if (schema.definitions) {
    Object.keys(schema.definitions).forEach(function (key) {
      schema.definitions[key] = getFieldSchema(_extends({}, props, {
        schema: schema.definitions[key]
      }));
    });
  } // properties


  if (schema.properties) {
    Object.keys(schema.properties).forEach(function (key) {
      schema.properties[key] = getFieldSchema(_extends({}, props, {
        schema: schema.properties[key]
      }));
    });
  } // items


  if (schema.items) {
    schema.items = getFieldSchema(_extends({}, props, {
      schema: schema.items
    }));
  } // additional items


  if (schema.additionalItems) {
    schema.additionalItems = getFieldSchema(_extends({}, props, {
      schema: schema.additionalItems
    }));
  } // retrieve schema


  schema = retrieveSchema(schema, definitions, formData); // get idSchema

  idSchema = mergeObjects(toIdSchema(schema, null, definitions, formData, idPrefix), idSchema); // set id

  let id;

  if (idPrefix && name) {
    id = idPrefix + '_' + name;
  } else {
    id = idSchema.$id;
  } // disabled, readonly, autofocus, hidden


  const disabled = Boolean(props.disabled || schema.disabled || uiSchema["ui:disabled"]);
  const readonly = Boolean(props.readonly || schema.readonly || uiSchema["ui:readonly"]);
  const autofocus = Boolean(props.autofocus || uiSchema["ui:autofocus"]);
  const hidden = Boolean(props.hidden || uiSchema["ui:hidden"]); // hidden

  if (hidden) {
    uiSchema["ui:widget"] = "hidden";
  }

  const __errors = errorSchema.__errors,
        fieldErrorSchema = _objectWithoutPropertiesLoose(errorSchema, ["__errors"]); // get uiOptions


  let uiOptions = getUiOptions(uiSchema); // set language

  return _extends({}, props, {
    id: id,
    idSchema: idSchema,
    schema: schema,
    uiSchema: uiSchema,
    uiOptions: uiOptions,
    formData: formData,
    formContext: formContext,
    registry: registry,
    disabled: disabled,
    readonly: readonly,
    hidden: hidden,
    autofocus: autofocus,
    errorSchema: errorSchema,
    rawErrors: __errors
  });
}